<div class="modal-header">
  <h4 class="modal-title fw-normal">{{ title }}</h4>
</div>
<div class="modal-body">
  <div class="alert alert-success d-flex px-2 py-3 align-items-center gap-2">
    <i class="bi bi-check-circle-fill"></i>
    <div id="success-message" class="text">{{ successMessage }}</div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary fw-normal" (click)="onClose()">Close</button>
</div>
